export default __webpack_public_path__ + "static/media/GES_A_WHITE.52e63623.png";